export function graceDefineCustomElement(tagName, constructor) {
    if (typeof customElements === 'undefined') {
        return;
    }
    if (customElements.get(tagName)) {
        return;
    }
    customElements.define(tagName, constructor);
}
//# sourceMappingURL=grace-define-custom-element.js.map